import type { Dispatch, SetStateAction } from "react";

export type InitialState<T> = T | (() => T);

export type SetState<T> = Dispatch<SetStateAction<T>>;

export type State<T> = [T, SetState<T>];

export function initialize<T>(initialState: InitialState<T>): T {
  return isInitializer(initialState) ? initialState() : initialState;
}

function isInitializer<T>(
  initialState: InitialState<T>,
): initialState is () => T {
  return typeof initialState === "function";
}
